
<div mat-dialog-title>1RM Calculated</div>
<mat-dialog-content>
  <p>Your 1RM for {{ data.exerciseName }} is {{ data.results['1rm'] | number: '1.0-0' }} lbs.</p>
  <p>The FitForce app will automatically adjust this based on your workouts and performance.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="closeDialog()" fxFlex>Close</button>
</mat-dialog-actions>
